import { pBase } from './.catalog';

export default class pUiLog extends pBase {
  constructor(options: {
    LogSeviyesi: string;
    Mesaj: string;
    StackTrace: string;
    MobilMi: boolean;
    VersiyonIsmi: string;
    VersiyonKodu: number;
    Ortam: string;
    BrowserUserAgent: string;
    BrowserOzellikleri: string;
    MobilOzellikleri: string;
  }) {
    super();
    this.LogSeviyesi = options.LogSeviyesi;
    this.Mesaj = options.Mesaj;
    this.StackTrace = options.StackTrace;
    this.MobilMi = options.MobilMi;
    this.VersiyonIsmi = options.VersiyonIsmi;
    this.VersiyonKodu = options.VersiyonKodu;
    this.Ortam = options.Ortam;
    this.BrowserUserAgent = options.BrowserUserAgent;
    this.BrowserOzellikleri = options.BrowserOzellikleri;
    this.MobilOzellikleri = options.MobilOzellikleri;
  }

  public LogSeviyesi: string = '-';
  public Mesaj: string = '-';
  public StackTrace: string = '-';
  public MobilMi: boolean = false;
  public VersiyonIsmi: string = '-';
  public VersiyonKodu: number = 1;
  public Ortam: string = '-';
  public BrowserUserAgent = '-';
  public BrowserOzellikleri = '-';
  public MobilOzellikleri = '-';
}
